import { store } from '../../store/store';

const CURRENT_VERSION = '1.0.4'; // Укажи текущую версию хранилища
const STORAGE_VERSION_KEY = 'storage_version';
const ID = 19349;

export function initializeStorage(id: number) {
    if (id !== ID) return;

    const savedVersion = localStorage.getItem(STORAGE_VERSION_KEY);
    console.log(savedVersion, CURRENT_VERSION);
    if (savedVersion !== CURRENT_VERSION) {
        console.log(
            `Очистка localStorage. Старая версия: ${savedVersion}, новая версия: ${CURRENT_VERSION}, userId: ${id}`
        );

        // Полная очистка localStorage
        localStorage.clear();

        // Установить флаг новой версии
        localStorage.setItem(STORAGE_VERSION_KEY, CURRENT_VERSION);
        window.location.reload();
        throw new Error(
            `Очистка localStorage. Старая версия: ${savedVersion}, новая версия: ${CURRENT_VERSION}, userId: ${id}`
        );
    } else {
        console.log('localStorage уже актуален.');
    }
}
